import CapturedField from "./CapturedField";

export default class RedemptionRequest {

  constructor(jsonResponse) {
    if (jsonResponse) {
      this.id = jsonResponse["id"];
      this.transactionId = jsonResponse["transaction-id"];
      this.registrationId = jsonResponse["registration-id"];
      this.capturedFields = [];
      if (jsonResponse["captured-fields"]) {
        jsonResponse["captured-fields"].forEach(field => {
          this.capturedFields.push(new CapturedField(field));
        })
      }
    }
  }

  static create(registrationId, transactionId, capturedFields) {
    let json = {};
    json.registrationId = registrationId;
    json.transactionId = transactionId;
    json.capturedFields = capturedFields;
    return json;
  }

  static createWithDocuments(registrationId, transactionId, capturedFields, documents) {
    let json = {};
    json.registrationId = registrationId;
    json.transactionId = transactionId;
    json.capturedFields = capturedFields;
    json.documents = documents;
    return json;
  }

  static toJson(obj) {
    let json = {};
    json["registration-id"] = obj.registrationId;
    json["transaction-id"] = obj.transactionId;
    json["captured-fields"] = obj.capturedFields;
    return json;
  }

  static toJsonWithRequiredDocuments(obj) {
    let json = {};
    json["registration-id"] = obj.registrationId;
    json["transaction-id"] = obj.transactionId;
    json["captured-fields"] = obj.capturedFields;
    json["documents"] = obj.documents;
    return json;
  }
}
